<div [formGroup]="form">
    <input
        [formControlName]="fieldName"
        [id]="fieldName"
        type="tel"
        [placeholder]="formField.placeholder"
        class="form-control"
        [ngClass]="{ 'is-invalid': !isValid && (isDirty || isTouched) }"
        [attr.autocomplete]="formField.autocomplete !== '' ? formField.autocomplete : null"
        [attr.aria-labelledby]="fieldName + '-label'"
        [attr.aria-describedby]="fieldName + '-error-required ' + fieldName + '-error-pattern'"
    />
    <otb-form-error-message
        [id]="fieldName + '-error-required'"
        class="required"
        [show]="!isValid && (isDirty || isTouched) && errors?.['required']"
        [text]="'dynamische_frontend_validatoren.persönliche_daten.telefon_nicht_leer' | translate"
    >
    </otb-form-error-message>
    <otb-form-error-message
        [id]="fieldName + '-error-pattern'"
        class="pattern"
        [show]="!isValid && (isDirty || isTouched) && errors?.['pattern'] !== undefined"
        [text]="'dynamische_frontend_validatoren.persönliche_daten.telefon_ungültige_symbole' | translate"
    >
    </otb-form-error-message>
</div>
